import Swiper from "swiper"
import { Autoplay } from "swiper/modules"
import "swiper/css"

export function initHero() {
  const el = document.querySelector(".hero-swiper")
  if (!el) return

  new Swiper(el, {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
  })
}
